import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import React from "react";
import { cn } from "@/lib/utils";

export interface IconProps extends Omit<FontAwesomeIconProps, "icon"> {
  icon: IconDefinition;
  className?: string;
  size?:
    | "xs"
    | "sm"
    | "lg"
    | "xl"
    | "2xl"
    | "1x"
    | "2x"
    | "3x"
    | "4x"
    | "5x"
    | "6x"
    | "7x"
    | "8x"
    | "9x"
    | "10x";
}

const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ icon, className, size = "1x", ...props }, ref) => {
    return (
      <FontAwesomeIcon
        ref={ref}
        icon={icon}
        size={size}
        className={cn("inline-block", className)}
        {...props}
      />
    );
  },
);

Icon.displayName = "Icon";

export { Icon };
